<template>
  <authorization
    permissionKey="attendance_glasses_prescription"
    can="save"
    v-slot:default="{ authorization }"
  >
    <v-container fluid v-if="authorization">
      <v-row>
        <v-col class="text-h3 gray--text"> Receita de óculos </v-col>
        <v-col cols="auto">
          <v-btn
            color="gray lighten-1"
            dark
            :to="`/prontuario/${attendance.id}/receitas-oculos`">
            voltar
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <DynamicFormCore
            dynamicFormType="glasses_prescription"
            :answerableId="attendance.id"
            answerableType="Attendance"
          >
            <template v-slot:useButton="{ shard }">
              <v-btn
                v-if="shard.title !== 'Óculos em uso'"
                small
                color="light-blue"
                dark
                @click="importFrom(shard)"
                :disabled="signed"
              >
                usar
              </v-btn>
            </template>
          </DynamicFormCore>
        </v-col>
      </v-row>

      <v-row dense justify="end">
        <v-col cols="auto">
          <SaveStatus
            :saving="saveManager.isSaving"
            :pending="saveManager.pendingSave"
            :saved-at="glassesPrescriptionUpdatedAt"
            :error="saveManager.isError"
            not-saved-message="A Receita de Óculos ainda não foi salva."
            />
         </v-col>

        <v-col cols="auto">
          <v-btn
            outlined
            color="light-blue"
            @click="save"
            :loading="saveLoading"
            :disabled="!glassesPrescription || printLoading || saveLoading"
          >
           SALVAR 
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn
            outlined
            color="light-blue"
            @click="saveAndDownloadFile"
            :disabled="!glassesPrescription || printLoading || saveLoading"
            :loading=" printLoading"
          >
            SALVAR E IMPRIMIR
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <EsignButton
            :esign="glassesPrescription.lastEsign"
            v-if="glassesPrescription"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <GlassesPrescriptionFormDistanceGlasses
            ref="glassesPrescriptionFormDistanceGlasses"
            v-if="glassesPrescription"
            :isActive="hasDistanceGlasses"
            :attendance="attendance"
            :distanceGlasses="distanceGlasses"
            :glassesPrescriptionId="glassesPrescriptionId"
            :refreshGlassesPrescription="refreshGlassesPrescription"
            :facilitators="facilitators"
            :disabled="signed"
            @update-value="handleUpdateValue"
            @distance-glasses="
              (e) => {
                hasDistanceGlasses = e;
                debouncedSaveGlassesPrescription();
              }
            "
            :handleChange="handleChange"
          />

          <GlassesPrescriptionFormReadingGlasses
            ref="glassesPrescriptionFormReadingGlasses"
            v-if="glassesPrescription"
            :isActive="hasReadingGlasses"
            :attendance="attendance"
            :readingGlasses="readingGlasses"
            :glassesPrescriptionId="glassesPrescriptionId"
            :refreshGlassesPrescription="refreshGlassesPrescription"
            :facilitators="facilitators"
            :disabled="signed"
            :sphericalRightEyeFromDistance="sphericalRightEyeFromDistance"
            :sphericalLeftEyeFromDistance="sphericalLeftEyeFromDistance"
            :hasDistanceGlasses="hasDistanceGlasses"
            @reading-glasses="
              (e) => {
                hasReadingGlasses = e;
              }
            "
            :handleChange="handleChange"
          />
        </v-col>

        <v-col cols="6">
            <GlassesPrescriptionFormPupillaryDistance
              ref="glassesPrescriptionFormPupillaryDistance"
              v-if="glassesPrescription"
              :attendance="attendance"
              :glassesPrescriptionId="glassesPrescriptionId"
              :pupillaryDistance="pupillaryDistance"
              :refreshGlassesPrescription="refreshGlassesPrescription"
              :facilitators="facilitators"
              :disabled="signed"
              :handleChange="handleChange"
            />

          <v-combobox
            v-model="noteFacilitator"
            label="Facilitatores"
            dense
            hide-details
            outlined
            :items="noteFacilitators"
            @change="handlenoteFacilitatorChange"
            background-color="white"
            :disabled="signed"
          >
            <template v-slot:item="{ item }">
              <v-tooltip top max-width="450">
                <template v-slot:activator="{ on, attrs }">
                  <span :attrs="attrs" v-on="on">
                    {{ item | truncate(60) }}
                  </span>
                </template>

                <span>
                  {{ item }}
                </span>
              </v-tooltip>
            </template>
          </v-combobox>

          <v-textarea
            dense
            class="pt-4 "
            v-model="observations"
            v-uppercase
            placeholder=" "
            label="observações:"
            rows="12"
            outlined
            hide-details
            background-color="white"
            :disabled="signed"
            @input="handleChange"
          />


          <v-menu
            class="pt-0"
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="nextAttendanceDate"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
            >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
            class="pt-8"
               v-model="nextAttendanceDateFormatted"
               label="Próxima consulta"
               readonly
               dense
               outlined
               hide-details
               v-bind="attrs"
               v-on="on"
               background-color="white"
              :disabled="signed"
              />
            </template>

            <v-date-picker
              v-model="nextAttendanceDate"
              type="month"
              locale="pt-BR"
              :min="$moment().toISOString()"
              no-title
              scrollable >
              <v-spacer></v-spacer>

              <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(nextAttendanceDate)" @input="handleChange"> OK </v-btn>
              </v-date-picker>
           </v-menu>
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
import GlassesPrescriptionFormDistanceGlasses from "@/components/glasses_prescription/form/distance_glasses.vue";
import GlassesPrescriptionFormReadingGlasses from "@/components/glasses_prescription/form/reading_glasses.vue";
import GlassesPrescriptionFormPupillaryDistance from "@/components/glasses_prescription/form/pupillary_distance.vue";
import DynamicFormCore from "@/components/dynamic_form/core.vue";

import SAVE_GLASSES_PRESCRIPTION from "@/graphql/glasses_prescription/save_glasses_prescription.gql";
import GLASSES_PRESCRIPTION from "@/graphql/glasses_prescription/glasses_prescription.gql";
import FACILITATORS from "@/graphql/glasses_prescription/facilitators.gql";
import IMPORT_FROM_SHARD from "@/graphql/glasses_prescription/import_from_shard.gql";

import SaveStatus from "@/components/ui/form/save_status/index.vue";
import { AutoSaveManager } from "@/services/AutoSaveManager/index.js";

export default {
  name: "GlassesPrescription",
  props: {
    attendance: Object,
    glassesPrescriptionId: String,
  },
  components: {
    GlassesPrescriptionFormDistanceGlasses,
    GlassesPrescriptionFormReadingGlasses,
    GlassesPrescriptionFormPupillaryDistance,
    DynamicFormCore,
    SaveStatus,
  },
  data() {
    return {
      saveLoading: false,
      typing: false,
      observations: "",
      hasReadingGlasses: false,
      hasDistanceGlasses: false,
      menu: "",
      nextAttendanceDate: "",
      printLoading: false,
      facilitators: [],
      noteFacilitator: "",
      glassesPrescriptionUpdatedAt: "",

      sphericalRightEyeFromDistance: "",
      sphericalLeftEyeFromDistance: "",
    };
  },
  created: function () {
    this.nextAttendanceDate = this.$moment().add(1, "year").format("YYYY-MM");
    this.saveGlassesPrescription.nextAttendanceDate = this.nextAttendanceDate;
    this.debouncedSaveGlassesPrescription = this.lodash.debounce(
      this.saveGlassesPrescription,
      900000
    );
    this.saveManager = new AutoSaveManager({
      formName: "Receita de óculos",
      beforeSave: () => this.beforeSave(),
      onSave: () => this.saveGlassesPrescription(),
      autoSaveTimeout: 900000,
    })
  },
  apollo: {
    facilitators: {
      query: FACILITATORS,
      update: (data) => data.glassesPrescriptionFacilitators,
    },
    glassesPrescription: {
      query: GLASSES_PRESCRIPTION,
      variables() {
        return {
          glassesPrescriptionId: this.glassesPrescriptionId,
        };
      },
      skip() {
        return this.glassesPrescriptionId === "";
      },
      result({ data }) {
        if (!this.typing) {
          this.observations = data.glassesPrescription.observations;
        }
        this.hasReadingGlasses = data.glassesPrescription.hasReadingGlasses;
        this.hasDistanceGlasses = data.glassesPrescription.hasDistanceGlasses;

        if (data.glassesPrescription.nextAttendanceDate) {
          if (this.nextAttendanceDate === "") {
            this.nextAttendanceDate = this.$moment(
              data.glassesPrescription.nextAttendanceDate
            )
              .add(1, "year")
              .format("YYYY-MM");
          }
        } else {
          this.nextAttendanceDate = this.$moment()
            .add(1, "year")
            .format("YYYY-MM");
        }
      },
      pollInterval: 900000,
    },
  },
  computed: {
    distanceGlasses() {
      if (this.glassesPrescription) {
        return this.glassesPrescription.distanceGlasses;
      }

      return null;
    },
    readingGlasses() {
      if (this.glassesPrescription) {
        return this.glassesPrescription.readingGlasses;
      }

      return null;
    },
    pupillaryDistance() {
      if (this.glassesPrescription) {
        return this.glassesPrescription.pupillaryDistance;
      }

      return null;
    },
    nextAttendanceDateFormatted() {
      this.debouncedSaveGlassesPrescription();

      return this.$moment(this.nextAttendanceDate).format("MM/YYYY");
    },
    noteFacilitators() {
      let facilitator = this.lodash.find(this.facilitators, {
        facilitatorType: "notes",
      });

      if (facilitator) {
        return facilitator.values;
      }

      return [];
    },
    signed() {
      if (this.glassesPrescription) {
        return this.glassesPrescription.lastEsign.status !== "editable";
      }

      return false;
    },
  },
  methods: {
    handleUpdateValue(sphericalRightEyeFromDistance, sphericalLeftEyeFromDistance) {
      this.sphericalRightEyeFromDistance  = sphericalRightEyeFromDistance;
      this.sphericalLeftEyeFromDistance = sphericalLeftEyeFromDistance;
    },

    handlenoteFacilitatorChange(e) {
      if (this.signed) return;

      if (e) {
        this.observations += "\r\n";
        this.observations += `${e}`;
        this.observations = this.observations.trim();
        this.noteFacilitator = [];
      }
    },

    async refreshGlassesPrescription() {
      await this.$apollo.queries.glassesPrescription.refetch();
    },

    beforeSave() {
    return true;
    },

    async saveGlassesPrescription() {
      try {
        this.saveLoading = true;
    
        if (this.signed) return;
    
        const { data } = await this.apolloMutate({
          mutation: SAVE_GLASSES_PRESCRIPTION,
          variables: {
            attendanceId: this.attendance.id,
            glassesPrescriptionId: this.glassesPrescriptionId,
            observations: this.observations,
            hasReadingGlasses: this.hasReadingGlasses,
            hasDistanceGlasses: this.hasDistanceGlasses,
            nextAttendanceDate: this.nextAttendanceDate,
          },
        });

        this.typing = false;
        this.saveLoading = false;
        this.glassesPrescriptionId = data.saveGlassesPrescription.id;

        if (data.saveGlassesPrescription.updatedAt) {
          this.glassesPrescriptionUpdatedAt = data.saveGlassesPrescription.updatedAt;
        }

        this.refreshGlassesPrescription();
      } catch (error) {
        console.error('Erro ao salvar a prescrição de óculos:', error);
        this.saveLoading = false;
      }
    },

    async importFrom(shard) {
      if (this.signed) return;

      this.apolloMutate({
        mutation: IMPORT_FROM_SHARD,
        variables: {
          attendanceId: this.attendance.id,
          glassesPrescriptionId: this.glassesPrescriptionId,
          shardId: shard.id,
        },
      }).then(() => {
        this.refreshGlassesPrescription();
      });
    },
    async generatePreview() {
      await this.apolloMutate({
        mutation: require("@/graphql/esign/generate_preview.gql"),
        variables: {
          esignId: this.glassesPrescription.lastEsign.id,
        },
      });
    },
    async downloadFile() {
      if (this.glassesPrescription) {
        this.printLoading = true;
        await this.refreshGlassesPrescription();
        await this.generatePreview();
        await this.refreshGlassesPrescription();
        //await this.$store.dispatch("authentication/refreshToken");
        const file_url = this.glassesPrescription.lastEsign.fileUrl;
        await window.open(
          `${process.env.VUE_APP_BASE_URL}${file_url}`,
          "_blank"
        );
        this.printLoading = false;

      }
    },
    async save() {
      try {
        this.printLoading = true;

        if (this.glassesPrescription) {
          if (this.hasDistanceGlasses) {
            await this.$refs.glassesPrescriptionFormDistanceGlasses.saveDistanceGlasses();
          }

          if (this.hasReadingGlasses) {
            await this.$refs.glassesPrescriptionFormReadingGlasses.saveReadingGlassesAddition();
            await this.$refs.glassesPrescriptionFormReadingGlasses.saveReadingGlasses();
          }

          await this.$refs.glassesPrescriptionFormPupillaryDistance.savePupillaryDistance();
          await this.saveGlassesPrescription();
          await this.generatePreview();
        }

        this.printLoading = false;
        await this.saveManager._clearPendingSave();
      } catch (error) {
        console.error('Erro ao salvar a receita de óculos:', error);
        this.printLoading = false;
      }
    },
    async saveAndDownloadFile() {
      try {
        this.printLoading = true;

        if (this.glassesPrescription) {
          if (this.hasDistanceGlasses) {
            await this.$refs.glassesPrescriptionFormDistanceGlasses.saveDistanceGlasses();
          }

          if (this.hasReadingGlasses) {
            await this.$refs.glassesPrescriptionFormReadingGlasses.saveReadingGlassesAddition();
            await this.$refs.glassesPrescriptionFormReadingGlasses.saveReadingGlasses();
          }

          await this.$refs.glassesPrescriptionFormPupillaryDistance.savePupillaryDistance();
          await this.saveManager.onSave();
          await this.generatePreview();
          //disable temporarily await new Promise(resolve => setTimeout(resolve, 7000));
          await this.refreshGlassesPrescription();
          //await this.$store.dispatch("authentication/refreshToken");

          const file_url = this.glassesPrescription.lastEsign.fileUrl;
          await window.open(`${process.env.VUE_APP_BASE_URL}${file_url}`, "_blank");
        }

        this.printLoading = false;
        await this.saveManager._clearPendingSave();
      } catch (error) {
        console.error('Erro ao salvar e imprimir a receita de óculos:', error);
        this.printLoading = false;
      }
    },
    handleChange() {
      this.saveManager.dispatchAutoSave();
    }

  }
};
</script>

<style lang="scss" scoped></style>
